export function validateCheckoutOptions(data) {
  const p = data?.payment;
  const mode = data?.operating_mode;
  if (!p || !["demo", "live"].includes(mode)) throw new Error("Payment options are unavailable. Please retry.");
  if (mode === "live" && (data.card_simulated !== false || (p.configured && (p.provider !== "card_gateway" || p.is_test !== false)))) {
    throw new Error("Payment mode could not be confirmed. Please retry.");
  }
  if (mode === "demo" && (data.card_simulated !== true || p.provider !== "test" || p.is_test !== true)) {
    throw new Error("Payment mode could not be confirmed. Please retry.");
  }
  return data;
}
